_.templateSettings.interpolate = /{{([\s\S]+?)}}/g; //setting mustache style templating

/**** SIDECART VIEW ***/
(function () {
  let _private = {};

  var formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  });

  _private.cartType = ($('body').hasClass('purchasing')) ? 'sell' : 'buy';

  _private.buildSideCart = function (cartData) {
    let _arrProductList = [];
    let _arrCardList = [];
    let cartProductTypes = ['game', 'product'];
    let cartCardTypes = ['mtg_card', 'mtg_foil', 'mtg_intl'];
    let viewCartUrl = '/cart';
    let checkoutUrl = '/checkout';
    let _viewCart = 'View Cart';
    cartData.productListData = {};
    let _cart = cartData.items;

    if(_private.cartType !== 'sell') {
        _cart = _.sortBy(_cart, function(item) {
          return [item.title, item.product.model, item.edition, item.name];
        });
    }


    //BUILD PRODUCT LIST
    Object.keys(_cart).forEach(function (key) {
      if ($.inArray(_cart[key].product.model, cartProductTypes) >= 0) {
        let _productItem = {};
        _productItem.id =  _cart[key].product_id || _cart[key].id;
        _productItem.qty = _cart[key].qty;
        _productItem.name = _cart[key].name;
        _productItem.price = parseFloat(_cart[key].price).toFixed(2);
        _productItem.style = _cart[key].style;
        _productItem.touched = _cart[key].touched;
        _productItem.uri = _cart[key].product.uri;
        if (typeof _cart[key].ship_date !== 'undefined' && (_cart[key].ship_date).length > 1) {
          _productItem.ship_date = _cart[key].ship_date;
        }
        cartData.productListData[key] = _productItem;
      }
    });

    //BUILD SINGLES LIST
    cartData.cardListData = {};
    Object.keys(_cart).forEach(function (key) {
      if ($.inArray(_cart[key].product.model, cartCardTypes) >= 0) {
        let _productItem = {};
        _productItem.id = _cart[key].product_id || _cart[key].id;
        _productItem.model = _cart[key].product.model;
        _productItem.qty = _cart[key].qty;
        _productItem.name = _cart[key].title;
        _productItem.price = (parseFloat(_cart[key].price)).toFixed(2);
        _productItem.style = _cart[key].style;
        _productItem.edition = _cart[key].edition;
        _cart[key].variation = _cart[key].variation;
        _productItem.touched = _cart[key].touched;
        _productItem.uri = _cart[key].product.uri;
        if (typeof _cart[key].ship_date !== 'undefined' && (_cart[key].ship_date).length > 1) {
          _productItem.ship_date = _cart[key].ship_date;//_item.ship_date;
        }
        if(_productItem.qty > 0) {
          cartData.cardListData[key] = _productItem;
        }


      }
    });

    // BUILD SIDECART HEADER
    if(_private.cartType == 'sell') {
      viewCartUrl = '/sellcart';
      checkoutUrl = '/scheckout?dest=/scheckout';
      _viewCart = 'View Sell Cart';
    }
    let presales;

    cartData.cartlinks = '<div class="cartLinks"><a href="' + viewCartUrl + '" data-dd-action-name="Sidecart View Cart">' + _viewCart + '</a> | <a href="' + checkoutUrl + '" data-dd-action-name="Sidecart Checkout">Checkout</a></div>';
    cartData.subtotal = _private.calculateSubTotal(_cart);
    cartData.itemCount = '(' + _private.calculateCount(_cart) + ' items)';
    let productList = _private.buildProductListForSideCart(cartData.productListData);
    cartData.productList = productList.html;
    presales = productList.presales;
    let cardList = _private.buildCardListForSideCart(cartData.cardListData);
    cartData.cardList = cardList.html;
    presales = new Set(presales.concat(cardList.presales));

    cartData.hasitems = (Object.keys(cartData.productListData).length > 0 || Object.keys(cartData.cardListData).length > 0) ? 'hasitems' : '';
    
    cartData.presaleHtml = _private.buildPresaleHtml(presales.size);

    cartData.checkoutUrl = checkoutUrl;
    let _compiled = _private.sideCartCompileTemplate({'cartData': cartData});
    $('#sideCart').html(_compiled);
  };

  _private.calculateSubTotal = function (cart) {
    let subtotal = 0;
    Object.keys(cart).forEach(function (key) {
      subtotal = subtotal + (parseInt(cart[key].qty) * parseFloat(cart[key].price));
    });
    return formatter.format(subtotal);
  }

  _private.calculateCount = function (cart) {
    let count = 0;
    Object.keys(cart).forEach(function (key) {
      count = count + parseInt(cart[key].qty);
    });
    return count;
  }

  _private.sideCartCompileTemplate = _.template('<div class="sideCart {{cartData.hasitems}}">\
        <h5><span class="buyCartTitle">Shopping Cart</span><span class="sellCartTitle">Items I Am Selling</span></h5>\
        <div class="itemCount">{{cartData.itemCount}}</div>\
        <div class="subtotal">Subtotal: {{cartData.subtotal}} USD</div>\
        <div class="processingSpinner sideCartSpinner"></div>\
        <div class="cartLinks">{{cartData.cartlinks}}</div>\
        {{cartData.presaleHtml}}\
        <table class="sideCartList">\
        {{cartData.productList}}\
        {{cartData.cardList}}\
        </table>\
        <a href="{{cartData.checkoutUrl}}" class="checkoutButton" data-dd-action-name="Secure Checkout"><span class="glyphicon glyphicon-lock"></span><span class="secure">SECURE </span><span>CHECKOUT</span><span class="glyphicon glyphicon-triangle-right"></span></a>\
    </div>');

  _private.buildProductListForSideCart = function (productList) {
    let $newEl = $('<div></div>');
    let presales = new Set();
    let _newItem, _price, _touched, touchedId, _url = '', _style, _preorder, _shipDate;
    Object.keys(productList).forEach(function (key) {
      let item = productList[key];
      if (item.qty > 0) {
        _shipDate = item.ship_date || '';
        _preorder = '';
        if (_shipDate.length > 1) {
            _preorder = '<div class="preorder"><span class="glyphicon glyphicon-info-sign"></span> Available ' + _shipDate + '<span class="fullRestrictions"><span class="glyphicon glyphicon-info-sign"></span> <b>Available ' + _shipDate + '</b><br>This product will be available on ' + _shipDate + '.  <br><b>Please place in-stock items or items released earlier on a separate order if you want them shipped sooner.</b> </span></div>';
            presales.add(_shipDate);
        }
        _price = Number(item.price);
        _price = formatter.format(_price.toFixed(2));
        _touched = item.touched ? 'touched' : '';
        _url = '/catalog/item/' + item.id;
        _style = '&nbsp' + (item.style || '');
        if(_private.cartType == 'sell') {
          _newItem = '<tr valign=top class="productDescription ' + _touched + '"><td align=center>' + item.qty + '</td><td align=left>' + item.name + _style + _preorder + '</td><td align=right>' + _price + '</td></tr>\n';
        } else {
          _newItem = '<tr valign=top class="productDescription ' + _touched + '"><td align=center>' + item.qty + '</td><td align=left><a href="/' + item.uri + '">' + item.name + _style + '</a>' + _preorder + '</td><td align=right>' + _price + '</td></tr>\n';
        }
        $newEl.append(_newItem);
      }
    });
      return {
          html: $newEl.html(), // Return the generated HTML
          presales: Array.from(presales) // Convert Set to Array and return
      };
  };

  _private.buildPresaleHtml = function (presaleCount) {
    if (presaleCount === 1) {
      return ' <div>\n' +
          '                            <div class="cart-tag">\n' +
          '                                <div><div class="bold header"><div class="icon"><span>OHN</span></div> <div>Order Hold Notice: Presale Items</div></div></div>\n' +
          '                                <div>You have at least one presale item in your cart. We will hold your entire order until all items are available. If you would like items shipped sooner, please place separate orders.</div>' +
          '                            </div>\n' +
          '                        </div>';
    }
    if (presaleCount > 1) {
      return ' <div>\n' +
          '                            <div class="cart-tag">\n' +
          '                                <div><div class="bold header"><div class="icon"><span>OHN</span></div> <div>Order Hold Notice: Differing Release Dates</div></div></div>\n' +
          '                                <div>You have presale items in your cart with different release dates. We will hold your order until all items are available. If you would like items shipped sooner, please place separate orders.</div>\n' +
          '                        </div>'
    }
    return '';
  }

  _private.buildCardListForSideCart = function (productList) {
    let _arrNameList = [];
    let _foilTag;
    let _nameList = {};
    let _nameSet = {};
    let _newItem;
    let _price;
    let _touched = '';
    let _url = '';
    let _variation;
    let $newEl = $('<div></div>');
    let presales = new Set();
    let _preorder, _shipDate;

    Object.keys(productList).forEach(function (key) {
      let item = productList[key];
      if (item.qty > 0) {
        let _name = (_private.cartType == 'sell') ? item.edition : item.name;
        let key = encodeURIComponent(_name);
        if (typeof _nameList[key] == 'undefined') {
          _nameSet = {};
          _nameSet.name = _name;
          _nameSet.items = [];
          _nameList[key] = _nameSet;
        }
        _nameList[key].items.push(item);
      }
    });

    Object.keys(_nameList).forEach(function (key) {
      _arrNameList.push(_nameList[key]);
    });

    for (i = 0; i < productList.length; i++) {
      if (productList[i].qty > 0) {
        let _name = productList[i].name;
        let _key = encodeURIComponent(_name);
        if (typeof _nameList[_key] == 'undefined') {
          _nameSet = {};
          _nameSet.name = _name;
          _nameSet.items = [];
          _nameList[_key] = _nameSet;
        }
        _nameList[_key].items.push(productList[i]);
      }

    }

    Object.keys(_arrNameList).forEach(function (key) {
      let item = _arrNameList[key];
      _newItem = '<tr class="cardTitle"><td colspan="3">' + item.name + '</td></tr>';
      $newEl.append(_newItem);
      let _items = item.items;
      for (i = 0; i < _items.length; i++) {
        if (_items[i].qty > 0) {
          _price = Number(_items[i].price);
          _price = formatter.format(_price.toFixed(2));
          _shipDate = _items[i].ship_date || '';
          _preorder = '';
         if (_shipDate.length > 1) {
            _preorder = '<div class="preorder"> Available ' + _shipDate + '<span class="fullRestrictions"> <b>Available ' + _shipDate + '</b><br>This product will be available on ' + _shipDate + '.  <br><b>Please place in-stock items or items released earlier on a separate order if you want them shipped sooner.</b> </span></div>';
            presales.add(_shipDate);
         }

          _foilTag = '';
          _variation = '';
          if (_items[i].variation && _items[i].variation.length > 0) {
            _variation = ' - ' + _items[i].variation;
          }
          _url = '/catalog/item/' + _items[i].id;
          if (_items[i].model === 'mtg_foil') {
            _foilTag = '<span class="foil">FOIL</span>';
          }
          _touched = _items[i].touched ? 'touched' : '';
          let itemNameContents;
          if (_private.cartType == 'sell') {
            itemNameContents = (_items[i].name + _variation)
          } else {
            itemNameContents = _items[i].edition
            if (_items[i].style) {
              itemNameContents += ' (' + _items[i].style + ')'
            }
          }
          itemNameContents += _foilTag;
          _newItem = '<tr valign="top"  class="productDescription ' + _touched + '"><td align=center>' + _items[i].qty + '</td><td align=left><a href="/' + _items[i].uri + '">' + itemNameContents + '</a>' + _preorder + '</td><td align=right>' + _price +'</td></tr>\n';
          $newEl.append(_newItem);
        }
      }
    });
      return {
          html: $newEl.html(),
          presales: Array.from(presales)
      };
  };

  $(document).on('cartStartUpdate.ck', function () {
    //spinner
    $('#sideCart .subtotal, #sideCart .itemCount').css({'opacity': .1});
    setTimeout(function () {
      if (parseFloat($('#sideCart .subtotal').css('opacity')) < 1) {
        $('#sideCart .processingSpinner').addClass('activate');
      }
    }, 300);
  });

  $(document).on('cartUpdated.ck', function (evt) {
    _private.buildSideCart(window.ckCatalog.cart());
    $('#sideCart .subtotal, #sideCart .itemCount').css({'opacity': 1});
    setTimeout(function () {
      $('#sideCart .processingSpinner').removeClass('activate');
    }, 300);
  });

})();

